import _asyncToGenerator from "F:/vue2.0+ vant/2024\u5E74\u9879\u76EE\u96C6\u5408/\u5143\u7FBF\u5B98\u7F51\u9879\u76EE\u96C6\u5408/\u5143\u7FBF\u82F1\u6587\u7248\u672C/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import { ref, onMounted, reactive } from "vue";
import { getHomeCorporateAdvantageList_url } from "@/api"; //引入发送请求获取数据的方法

import { enGetCompanyTeamList_url } from "@/api"; //引入发送请求获取数据的方法

import { Swiper, SwiperSlide } from 'swiper/vue/swiper-vue.js';
import SwiperCore, { Navigation, Pagination, EffectFade, Grid } from 'swiper';
import 'swiper/swiper.min.css';
import 'swiper/modules/effect-fade/effect-fade.min.css'; //引入轮播样式-

import 'swiper/modules/pagination/pagination.min.css';
import 'swiper/modules/grid/grid.min.css';
export default {
  components: {
    Swiper: Swiper,
    SwiperSlide: SwiperSlide
  },
  name: "teamList",
  setup: function setup() {
    onMounted(function () {// getHomeCorporateAdvantageList()
    });
    var popFlag = ref(false);
    var types = ref(1);
    onMounted(function () {
      getCompanyTeamList({
        type: 1
      });
      getCompanyTeamList({
        type: 2
      });
    });
    var teamList = ref([{
      employment: ''
    }, {
      employment: ''
    }, {
      employment: ''
    }, {
      employment: ''
    }, {
      employment: ''
    }]);
    var ceoList = ref([{
      employment: ''
    }, {
      employment: ''
    }, {
      employment: ''
    }, {
      employment: ''
    }, {
      employment: ''
    }]);

    var getCompanyTeamList = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(val) {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return enGetCompanyTeamList_url(val);

              case 2:
                res = _context.sent;

                if (val.type == 1) {
                  teamList.value = res.data;
                }

                if (val.type == 2) {
                  ceoList.value = res.data;
                } // teamList.value = res.data
                // console.log(res,'创始人信息')


              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function getCompanyTeamList(_x) {
        return _ref.apply(this, arguments);
      };
    }(); // const num = ref(3)


    var showIndex = ref(0);

    var toggleMore = function toggleMore(index, type) {
      popFlag.value = !popFlag.value;
      showIndex.value = index;
      types.value = type;
    };

    var swiper_option = reactive({
      autoplay: {
        delay: 4000,
        disableOnInteraction: false
      },
      // fadeEffect: {
      //   crossFade: false,
      // },
      loop: true,
      speed: 1000,
      liner: true,
      grid: {
        // fill: 'column',
        rows: 2
      } // showNum: 3
      // on: {
      //   slideChangeTransitionEnd: handleSlideChange,
      // },

    });
    return {
      popFlag: popFlag,
      teamList: teamList,
      ceoList: ceoList,
      toggleMore: toggleMore,
      swiper_option: swiper_option,
      showIndex: showIndex,
      modules: [EffectFade, Pagination, Navigation, Grid],
      types: types
    };
  }
};